import type { InterviewSession, InterviewSessionPort } from '@thom/folio-domain/core/ports/interview-session'

const blank: InterviewSession = { staged: {}, drafts: {} }

const keyOf = (id: string): string => `folio:interview:${id}`

const createInterviewSessionAdapter = (): InterviewSessionPort => ({
	read: id => {
		try {
			const raw = window.localStorage.getItem(keyOf(id))

			return raw ? { ...blank, ...(JSON.parse(raw) as Partial<InterviewSession>) } : blank
		} catch {
			return blank
		}
	},

	write: (id, session) => {
		try {
			window.localStorage.setItem(keyOf(id), JSON.stringify(session))
		} catch {
			return
		}
	},
})

export { createInterviewSessionAdapter }
